export default __webpack_public_path__ + "static/media/boardLowSmall.min.62b8038b.png";